import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

/**
 * MainLayout Component
 * Wraps every page to provide consistent navigation and brand elements.
 */
const MainLayout = ({ children, lang, toggleLang }) => {
  const { pathname } = useLocation();
  const isAr = lang === 'ar';

  // ✅ SEO & Accessibility: Auto-scroll to top on page change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  // ✅ Accessibility: Synchronize HTML attributes with current language
  useEffect(() => {
    document.documentElement.dir = isAr ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang, isAr]);

  return (
    <div
      className={`min-h-screen flex flex-col bg-white ${isAr ? 'font-arabic' : 'font-sans'}`}
    >
      {/* Navigation - Language & Toggle State passed from App.jsx */}
      <Navbar lang={lang} toggleLang={toggleLang} />

      {/* Page Transition Wrapper */}
      <AnimatePresence mode='wait'>
        <motion.main
          key={pathname}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className='flex-grow pt-20' // Padding top to prevent Navbar overlap
        >
          {children}
        </motion.main>
      </AnimatePresence>

      {/* Persistent Global Elements */}
      <Footer lang={lang} />

      {/* WhatsApp Button - Positioned via internal logic for RTL */}
      <WhatsAppButton lang={lang} phone='96550097296' />

      {/* Global Toast / Notification Area (Optional Future Use) */}
      <div id='notifications-portal' />
    </div>
  );
};

export default MainLayout;
